<app-admin-sidebar></app-admin-sidebar>
<div class="admin-content">
<router-outlet></router-outlet>
</div>